import React from 'react'

interface Props {
  title: string
  text: string
}

const TextHero: React.FunctionComponent<Props> = ({ title, text }) => {
  return (
    <section className=" m-auto mb-[122px] max-w-screen-2xl pt-6 md:pt-16 lg:mb-[122px]">
      <div className="m-auto">
        <h1
          className="mt-10 mb-12 md:mb-[2.4rem] text-[32px] tracking-[0.0125em] lg:tracking-[-0.005em] text-center font-ttHovesDemiBold text-green-100 leading-bigTitle md:text-bigTitleMobile md:leading-bigTitle lg:text-7xl lg:leading-bigTitle mx-auto xl:mx-auto xl:max-w-screen-2xl"
          dangerouslySetInnerHTML={{ __html: `${title}` }}
        />
        <p
          className="mx-[18px] text-xl leading-normal text-green-100 text-center md:px-16 xl:px-0 lg:text-2xl lg:leading-normal xl:m-auto xl:w-[54%]"
          dangerouslySetInnerHTML={{ __html: `${text}` }}
        />
      </div>
    </section>
  )
}

export default TextHero
